export default {
  root: {
    '&:last-child': {
      paddingBottom: '16px'
    }
  }
  
};
